<div class="create-assessment-dialog">
  <div class="dialog-header">
    <div class="header-left">
      <div class="header-icon">
        <lucide-icon name="shield" [size]="20" />
      </div>
      <h2>
        {{ 'attackSimulationsPage.createDialog.title' | labelsProvider }}
      </h2>
    </div>
    <button class="close-button" (click)="onCancel()">
      <lucide-icon name="x" [size]="20" />
    </button>
  </div>

  <div class="dialog-body">
    <div class="info-banner">
      <lucide-icon name="info" [size]="16" />
      <span>
        {{ 'attackSimulationsPage.createDialog.infoBannerLine1' | labelsProvider }}
        <br />
        {{ 'attackSimulationsPage.createDialog.infoBannerLine2' | labelsProvider }}
      </span>
    </div>

    <div class="form-section">
      <label class="field-label">
        {{ 'attackSimulationsPage.createDialog.testNameLabel' | labelsProvider }}
      </label>
      <input
        type="text"
        class="text-input"
        [placeholder]="'attackSimulationsPage.createDialog.testNamePlaceholder' | labelsProvider"
        [ngModel]="testName()"
        (ngModelChange)="testName.set($event)"
      />
    </div>

    <div class="form-section">
      <div class="ai-service-header">
        <label class="field-label">
          {{ 'attackSimulationsPage.createDialog.aiServiceLabel' | labelsProvider }}
        </label>
        <span class="coming-soon-badge">
          <lucide-icon name="sparkles" [size]="14" />
          {{ 'attackSimulationsPage.createDialog.comingSoonBadge' | labelsProvider }}
        </span>
      </div>
      <div class="ai-service-value">
        <img src="assets/images/logo/m365Copilot.svg" alt="Microsoft 365" class="service-icon" />
        <span>
          {{ 'attackSimulationsPage.createDialog.aiServiceValue' | labelsProvider }}
        </span>
      </div>
    </div>

    <hr class="section-divider" />

    <div class="form-section">
      <label class="field-label">
        {{ 'attackSimulationsPage.createDialog.testScenarioLabel' | labelsProvider }}
      </label>
      <div class="scenario-name">
        {{ 'attackSimulationsPage.createDialog.testScenarioName' | labelsProvider }}
      </div>
      <div class="scenario-desc">
        {{ 'attackSimulationsPage.createDialog.testScenarioDesc' | labelsProvider }}
      </div>
    </div>

    <div class="form-section">
      <label class="field-label">
        {{ 'attackSimulationsPage.createDialog.attackStrategyLabel' | labelsProvider }}
      </label>

      <div class="strategy-cards">
        <button
          class="strategy-card"
          [class.selected]="selectedStrategy() === 'hr_data'"
          (click)="onSelectStrategy('hr_data')"
        >
          <div class="radio-circle">
            @if (selectedStrategy() === 'hr_data') {
              <div class="radio-dot"></div>
            }
          </div>
          <div class="card-content">
            <span class="card-title">
              {{ 'attackSimulationsPage.createDialog.strategies.hrData' | labelsProvider }}
            </span>
            <span class="card-desc">
              {{ 'attackSimulationsPage.createDialog.strategies.hrDataDesc' | labelsProvider }}
            </span>
          </div>
        </button>

        <button
          class="strategy-card"
          [class.selected]="selectedStrategy() === 'financial_data'"
          (click)="onSelectStrategy('financial_data')"
        >
          <div class="radio-circle">
            @if (selectedStrategy() === 'financial_data') {
              <div class="radio-dot"></div>
            }
          </div>
          <div class="card-content">
            <span class="card-title">
              {{ 'attackSimulationsPage.createDialog.strategies.financialData' | labelsProvider }}
            </span>
            <span class="card-desc">
              {{ 'attackSimulationsPage.createDialog.strategies.financialDataDesc' | labelsProvider }}
            </span>
          </div>
        </button>

        <button
          class="strategy-card"
          [class.selected]="selectedStrategy() === 'general'"
          (click)="onSelectStrategy('general')"
        >
          <div class="radio-circle">
            @if (selectedStrategy() === 'general') {
              <div class="radio-dot"></div>
            }
          </div>
          <div class="card-content">
            <span class="card-title">
              {{ 'attackSimulationsPage.createDialog.strategies.general' | labelsProvider }}
            </span>
            <span class="card-desc">
              {{ 'attackSimulationsPage.createDialog.strategies.generalDesc' | labelsProvider }}
            </span>
            <span class="general-hint">
              <lucide-icon name="info" [size]="14" />
              {{ 'attackSimulationsPage.createDialog.strategies.generalHint' | labelsProvider }}
            </span>
          </div>
        </button>

        <button
          class="strategy-card"
          [class.selected]="selectedStrategy() === 'custom'"
          (click)="onSelectStrategy('custom')"
        >
          <div class="radio-circle">
            @if (selectedStrategy() === 'custom') {
              <div class="radio-dot"></div>
            }
          </div>
          <div class="card-content">
            <span class="card-title">
              {{ 'attackSimulationsPage.createDialog.strategies.custom' | labelsProvider }}
            </span>
            <textarea
              class="custom-textarea"
              [placeholder]="'attackSimulationsPage.createDialog.strategies.customPlaceholder' | labelsProvider"
              [ngModel]="customContext()"
              (ngModelChange)="onCustomContextChange($event)"
              [maxlength]="maxCustomLength"
              rows="2"
            ></textarea>
            <span class="char-count"> {{ customContext().length }}/{{ maxCustomLength }} </span>
          </div>
        </button>
      </div>
    </div>

    <div class="form-section">
      <label class="field-label">
        {{ 'attackSimulationsPage.createDialog.userAuthLabel' | labelsProvider }}
      </label>
      <p class="auth-desc">
        {{ 'attackSimulationsPage.createDialog.userAuthDesc' | labelsProvider }}
      </p>

      @if (!authCode()) {
        <button class="sign-in-button" (click)="onSignIn()" [disabled]="isAuthenticating()">
          <img src="assets/images/logo/ms-logo.svg" alt="Microsoft" class="ms-icon" />
          {{ 'attackSimulationsPage.createDialog.signInWithMicrosoft' | labelsProvider }}
        </button>

        @if (authError() === 'adminConsentRequired') {
          <div class="auth-error admin-consent-error">
            <lucide-icon name="triangle-alert" [size]="16" />
            <span>
              {{ 'attackSimulationsPage.createDialog.adminConsentError' | labelsProvider }}
            </span>
          </div>
        } @else if (authError() === 'signInFailed') {
          <div class="auth-error">
            <lucide-icon name="triangle-alert" [size]="16" />
            <span>
              {{ 'attackSimulationsPage.createDialog.signInError' | labelsProvider }}
            </span>
          </div>
        }

        @if (!isProduction && authError()) {
          <button class="dev-test-button" (click)="onUseTestAccount()">
            {{ 'attackSimulationsPage.createDialog.useTestAccount' | labelsProvider }}
          </button>
        }
      } @else {
        <div class="authenticated-user">
          <div class="user-info">
            <lucide-icon name="check-circle-2" [size]="16" class="check-icon" />
            <span>
              @if (authenticatedUser()) {
                {{ 'attackSimulationsPage.createDialog.connectedAs' | labelsProvider }}
                {{ authenticatedUser() }}
              } @else {
                {{ 'attackSimulationsPage.createDialog.connected' | labelsProvider }}
              }
            </span>
          </div>
          <button class="change-user-link" (click)="onChangeUser()">
            {{ 'attackSimulationsPage.createDialog.changeUser' | labelsProvider }}
          </button>
        </div>
      }

      <div class="session-safety">
        <div class="safety-header">
          <lucide-icon name="shield-check" [size]="14" />
          <span class="safety-title">
            {{ 'attackSimulationsPage.createDialog.sessionSafetyTitle' | labelsProvider }}
          </span>
        </div>
        <div class="safety-items">
          <span>{{ 'attackSimulationsPage.createDialog.sessionSafetyItems.userScoped' | labelsProvider }}</span>
          <span class="safety-dot"></span>
          <span>{{ 'attackSimulationsPage.createDialog.sessionSafetyItems.readOnly' | labelsProvider }}</span>
          <span class="safety-dot"></span>
          <span>{{
            'attackSimulationsPage.createDialog.sessionSafetyItems.noPersistentChanges' | labelsProvider
          }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <button class="cancel-button" (click)="onCancel()">
      {{ 'attackSimulationsPage.createDialog.cancelButton' | labelsProvider }}
    </button>
    <button class="run-button" [disabled]="!isFormValid" (click)="onRunAssessment()">
      {{ 'attackSimulationsPage.createDialog.runAssessmentButton' | labelsProvider }}
    </button>
  </div>
</div>
